export enum EndBreakResponseCode {
  Success,
  CannotEndRestrictedBreakEarly,
  ErrorUpdatingEventBreak,
  UserNotAtSpecifiedLocation,
  EventDoesNotMatchCurrentUser,
  BreakNoLongerExists,
}
